export const WEBSITE_BANNER_HEIGHT_MOBILE = 68;
export const WEBSITE_BANNER_HEIGHT_DESKTOP = 77;

/**
 * Lowest wins. Action-required first, promotional last — a host whose site is still hidden needs to
 * see that before an app promo. Gaps of 10 leave room to insert without renumbering.
 */
export const WEBSITE_BANNER_PRIORITY = {
  unpublishedWebsite: 10,
  accommodationsVisibility: 20,
  changesReminder: 30,
  inAppBrowser: 40,
  smartApp: 50,
} as const;
